export type AppPublicConfigurationDTO = {
    region: string;
    fusionAuthClientId: string;
};

export type AppPrivateConfigurationDTO = {
    region: string;
    appSyncKey: string;
    appSyncUrl: string;
    mixPanelToken: string;
};

export abstract class IAppConfigurationDAO {
    public abstract getPublicConfiguration(): Promise<AppPublicConfigurationDTO>;
    public abstract getPrivateConfiguration(): Promise<AppPrivateConfigurationDTO>;
}
